import { TouchableOpacity } from 'react-native';
import { Grid, Typography, Box } from '@mui/material';
import { useScreenComponent } from '../../app/hooks/custom/useScreenComponent';
import { ScreenComponent } from '../../models/enums/ScreenComponents';
import { useStoreConfig } from '../../contexts/StoreConfigContext';
import { productStore } from '../../app/stores/Product';
import { userStore } from '../../app/stores/User';
import { navigationStore } from '../../app/stores/Navigation';

// Brand/Logo Section
const BrandSection = () => {
    const { config } = useStoreConfig();
    
    // Use Google Font if set, otherwise use local font
    const logoFontFamily = config.logoFont ? `'${config.logoFont}', sans-serif` : 'logoFont';

    return (
        <Grid item xs={12} md={3} sx={{ mb: { xs: 4, md: 0 } }}>
            <Typography
                variant="h5"
                gutterBottom
                sx={{
                    color: '#fff',
                    fontWeight: 700,
                    fontFamily: logoFontFamily,
                    letterSpacing: '1px',
                    mb: 3,
                    textAlign: { xs: 'center', md: 'left' }
                }}>
                {config.companyName.toUpperCase()}
            </Typography>
            <Typography variant="subtitle2" sx={{ color: "#fff", opacity: 0.8, maxWidth: { xs: "100%", md: "90%" }, textAlign: { xs: "center", md: "left" } }}>
                {config.footerDescription}
            </Typography>
        </Grid>
    );
};

// Product Categories Section
const ProductCategoriesSection = () => {
    const { navigateToScreen } = useScreenComponent();
    const { allCategories } = productStore((state) => state);

    // Get unique categories, excluding "All" and limit to 5
    const categories = allCategories
        .filter(cat => cat.category !== "All")
        .slice(0, 5);

    return (
        <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
                mb: { xs: 4, md: 0 },
                textAlign: { xs: "center", md: "left" },
            }}
        >
            <Typography variant="subtitle2" gutterBottom sx={{
                color: "#fff",
                fontWeight: 600,
                letterSpacing: "0.5px",
                mb: 3
            }}>
                PRODUCT CATEGORIES
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                {categories.length > 0 ? (
                    categories.map((cat) => (
                        <TouchableOpacity
                            key={cat.category}
                            onPress={() => navigateToScreen(ScreenComponent.Shop, { category: cat.category })}
                        >
                            <Typography variant="caption" sx={{
                                color: "#fff",
                                opacity: 0.7,
                                mb: 1.5,
                                transition: "opacity 0.3s ease",
                                "&:hover": { opacity: 1, fontWeight: 600 }
                            }}>
                                {cat.category.toUpperCase()}
                            </Typography>
                        </TouchableOpacity>
                    ))
                ) : (
                    <Typography variant="caption" sx={{
                        color: "#fff",
                            opacity: 0.5,
                            mb: 1.5,
                    }}>
                        No categories available
                    </Typography>
                )}
            </Box>
        </Grid>
    );
};


// Resources Section
const ResourcesSection = () => {
    const { navigateToScreen } = useScreenComponent();
    const { user } = userStore((state) => state);
    const { updateProfileDrawerOpen } = navigationStore((state) => state);
    const isSignedIn = user.authenticated;

    return (
        <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
                mb: { xs: 4, md: 0 },
                textAlign: { xs: 'center', md: 'left' },
            }}
        >
            <Typography variant='subtitle2' gutterBottom sx={{
                color: '#fff',
                fontWeight: 600,
                letterSpacing: '0.5px',
                mb: 3,
            }}>
                QUICK LINKS
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <TouchableOpacity onPress={() => navigateToScreen(ScreenComponent.Shop)}>
                    <Typography variant='caption' sx={{
                        color: '#fff',
                        opacity: 0.7,
                        mb: 1.5,
                        transition: 'opacity 0.3s ease',
                        '&:hover': { opacity: 1, fontWeight: 600 }
                    }}>SHOP</Typography>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => navigateToScreen(ScreenComponent.Orders)}>
                    <Typography variant='caption' sx={{
                        color: '#fff',
                        opacity: 0.7,
                        mb: 1.5,
                        transition: 'opacity 0.3s ease',
                        '&:hover': { opacity: 1, fontWeight: 600 }
                    }}>MY ORDERS</Typography>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => navigateToScreen(ScreenComponent.Cart)}>
                    <Typography variant='caption' sx={{
                        color: '#fff',
                        opacity: 0.7,
                        mb: 1.5,
                        transition: 'opacity 0.3s ease',
                        '&:hover': { opacity: 1, fontWeight: 600 }
                    }}>CART</Typography>
                </TouchableOpacity>
                {!isSignedIn && (
                    <TouchableOpacity onPress={() => updateProfileDrawerOpen(true)}>
                        <Typography variant='caption' sx={{
                            color: '#fff',
                            opacity: 0.7,
                            mb: 1.5,
                            transition: 'opacity 0.3s ease',
                            '&:hover': { opacity: 1, fontWeight: 600 }
                        }}>SIGN IN</Typography>
                    </TouchableOpacity>
                )}
            </Box>
        </Grid>
    );
};


export const FooterTopSection = () => {
    return (
        <Grid
            container
            justifyContent={{ xs: "center", md: "space-between" }}
            spacing={3}
        >
            <BrandSection />
            <Grid
                item
                xs={12}
                md={8}
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { xs: "center", sm: "flex-end" },
                    gap: { xs: 0, sm: 2 }
                }}
            >
                <ResourcesSection />
                <ProductCategoriesSection />
            </Grid>
        </Grid>
    );
}; 